import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { breakpoints, colors } from "@/styles/utils/vars";
export const StyledListDotted = /*#__PURE__*/styled('ul')({
  name: "StyledListDotted",
  class: "StyledListDotted_sdik50p"
});
export const StyledListItemDotted = /*#__PURE__*/styled('li')({
  name: "StyledListItemDotted",
  class: "StyledListItemDotted_s11wocrw"
});
export const cssListDottedImage = "cssListDottedImage_c10tdquv";
export const StyledListDottedImageContainer = /*#__PURE__*/styled('div')({
  name: "StyledListDottedImageContainer",
  class: "StyledListDottedImageContainer_s135qkbr"
});

require("./StyledListDotted.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledListDotted.tsx");